import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import logo from "../assets/logo.webp";
import { FaTwitter, FaLinkedin, FaFacebook, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Footer = () => {
  const [isOtherOpen, setIsOtherOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleOtherMenu = () => {
    setIsOtherOpen(!isOtherOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOtherOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const otherLinks = [
    { text: "Interview Questions", url: "https://www.pcds.co.in/all-common-interview-questions-and-answers.php" },
    { text: "eBooks", url: "https://www.pcds.co.in/ebooks-free-download.php" },
    { text: "Jobs", url: "https://www.pcds.co.in/jobs/" },
    { text: "Biodata Format", url: "https://www.pcds.co.in/biodata-format.php" },
    { text: "Training", url: "https://www.pcds.co.in/training.php" },
    { text: "Author", url: "https://www.pcds.co.in/author-list.php" },
    { text: "Game", url: "https://www.pcds.co.in/game-download.php" },
    { text: "Bollywood Movie", url: "https://www.pcds.co.in/bollywood-movie.php" },
    { text: "Bollywood Actress", url: "https://www.pcds.co.in/bollywood-actress.php" },
    { text: "Hollywood Actress", url: "https://www.pcds.co.in/hollywood-actress.php" },
    { text: "Company List", url: "https://www.pcds.co.in/all-indian-company-name-list.php" },
    { text: "Cricketers Name", url: "https://www.pcds.co.in/all-cricketers-name.php" },
    { text: "Members Name", url: "https://www.pcds.co.in/members.php" },
    { text: "All Question", url: "https://www.pcds.co.in/all-freshers-interview-questions-and-answers.php" }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Top Section */}
        <div className="footer-top">
          <div className="footer-logo-section">
            <div className="footer-logo-container">
              <img src={logo} alt="PCDS Infotech Logo" className="footer-logo-img" />
            </div>
            <p className="footer-tagline">
              Your Vision, Our Expertise – Seamless Digital Solutions
            </p>
            <div className="footer-social-links">
              <a href="https://x.com/pcdsinfotech" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaTwitter />
              </a>
              <a href="https://www.linkedin.com/company/pcds-infotech" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaLinkedin />
              </a>
              <a href="https://www.facebook.com/pcdsinfotech" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaFacebook />
              </a>
            </div>
          </div>
          <div className="footer-links">
            <div className="footer-links-column">
              <h3 className="footer-links-title">Quick Links</h3>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/case-studies">Case Study</Link>
                </li>
                <li className="footer-dropdown" ref={dropdownRef}>
                  <div className="footer-dropdown-header" onClick={toggleOtherMenu}>
                    Other
                    {isOtherOpen ? <FaChevronUp className="dropdown-icon" /> : <FaChevronDown className="dropdown-icon" />}
                  </div>
                  {isOtherOpen && (
                    <ul className="footer-dropdown-menu">
                      {otherLinks.map((link, index) => (
                        <li key={index}>
                          <a href={link.url} target="_blank" rel="noopener noreferrer" className="dactive">
                            {link.text}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              </ul>
            </div>

            <div className="footer-links-column">
              <h3 className="footer-links-title">Services</h3>
              <ul>
                <li>
                  <Link to="/services/web-development">Web Development</Link>
                </li>
                <li>
                  <Link to="/services/web-maintenance">Web Maintenance</Link>
                </li>
                <li>
                  <Link to="/services/ai-surveillance">AI Surveillance</Link>
                </li>
                <li>
                  <Link to="/services/enterprise-software">Enterprise Software</Link>
                </li>
                <li>
                  <Link to="/services/ecommerce">E-Commerce Solutions</Link>
                </li>
              </ul>
            </div>

            <div className="footer-links-column">
              <h3 className="footer-links-title">Contact</h3>
              <ul>
                <li>
                  <span>Corporate Office</span>
                  <p className="footer-address">1st Floor Mukta tawar Near Andheri Station, Andheri West, Mumbai - 400058</p>
                </li>
                <li>
                  <a href="mailto:info@PCDS.in">info@PCDS.in</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            © {new Date().getFullYear()} PCDS Infotech. All rights reserved.
          </div>
          <div className="footer-legal-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>

      {/* Animated border */}
      <div className="footer-border"></div>
    </footer>
  );
};

export default Footer;